export function getNextColor(config) {
  const strength = Math.max(0, Math.min(1, (config.colorStrength ?? 20) / 100)); // Default to 0.2

  let color;
  if (Array.isArray(config.parsedColors) && config.parsedColors.length > 0) {
    color = config.parsedColors[config.colorCycleIndex];
    config.colorCycleIndex =
      (config.colorCycleIndex + 1) % config.parsedColors.length;
  } else {
    color = HSVtoRGB(Math.random(), 1.0, 1.0);
  }

  return {
    r: color.r * strength,
    g: color.g * strength,
    b: color.b * strength,
  };
}

export function HSVtoRGB(h, s, v) {
  let r, g, b, i, f, p, q, t;
  i = Math.floor(h * 6);
  f = h * 6 - i;
  p = v * (1 - s);
  q = v * (1 - f * s);
  t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = p;
      g = v;
      b = t;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    case 5:
      r = v;
      g = p;
      b = q;
      break;
    default:
      break;
  }
  return { r, g, b };
}

export function wrap(value, min, max) {
  const range = max - min;
  if (range === 0) return min;
  return ((value - min) % range) + min;
}

export function getResolution(gl, resolution) {
  // Added gl as a parameter
  let aspectRatio = gl.drawingBufferWidth / gl.drawingBufferHeight;
  if (aspectRatio < 1) aspectRatio = 1.0 / aspectRatio;
  const min = Math.round(resolution);
  const max = Math.round(resolution * aspectRatio);
  if (gl.drawingBufferWidth > gl.drawingBufferHeight)
    return { width: max, height: min };
  else return { width: min, height: max };
}

export function scaleByPixelRatio(input) {
  const pixelRatio = window.devicePixelRatio || 1;
  return Math.floor(input * pixelRatio);
}
